import React from 'react';
import { Link } from 'react-router-dom';

// Import images (update paths based on your actual images)
import vegetablesFruits from '../../assets/images/vegetables.jpg';
import riceWheatCereals from '../../assets/images/rice,wheat.jpg';
import spices from '../../assets/images/spices.jpg';

const exportProducts = [
  {
    id: 1,
    title: 'Vegetables & Fruits',
    description:
      'Our fresh vegetables and fruits are harvested at peak ripeness and carefully processed to lock in essential nutrients, natural flavors, and vibrant colors. Sourced from trusted farms across India, we ensure premium quality produce that meets international standards for global export.',
    icon: null,
    image: vegetablesFruits,
  },
  {
    id: 2,
    title: 'Rice, Wheat & Cereals',
    description:
      'Premium quality rice, wheat, and cereals sourced from India\'s finest agricultural regions. Our grains are carefully processed and packaged to preserve freshness, nutritional value, and authentic taste. Meeting international quality standards for global distribution.',
    icon: null,
    image: riceWheatCereals,
  },
  {
    id: 3,
    title: 'Spices',
    description:
      'Authentic Indian spices, carefully selected from renowned growing regions. From vibrant turmeric and aromatic cardamom to bold cumin and rich coriander, our spices deliver exceptional flavor and aroma. Processed and packaged to retain their natural oils and potency.',
    icon: null,
    image: spices,
  },
];

const Export = () => {
  return (
    <section className="section-y bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <p className="section-kicker">Global reach</p>
          <h2 className="section-title">Export Division</h2>
          <p className="section-subtitle">
            Premium Indian products exported worldwide with quality and excellence
          </p>
        </div>

        {/* Export Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {exportProducts.map((product) => (
            <div
              key={product.id}
              className="card-surface overflow-hidden group flex flex-col"
            >
              {/* Image */}
              <div className="h-56 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6 lg:p-7 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-navy mb-3 tracking-tight">
                  {product.title}
                </h3>
                <p className="text-darkGray/75 leading-relaxed text-sm flex-grow">
                  {product.description}
                </p>

                <Link
                  to="/contact"
                  className="mt-5 text-teal font-semibold hover:text-navy transition-colors duration-200 inline-flex items-center gap-1.5 w-fit"
                >
                  Contact Us
                  <span
                    className="group-hover:translate-x-1 transition-transform"
                    aria-hidden
                  >
                    →
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Export;